import { TEMPLATE_STATUS } from '../../../constants/messageTemplateKeys';

const LABELS = {
  [TEMPLATE_STATUS.DRAFT]: 'Draft',
  [TEMPLATE_STATUS.PUBLISHED]: 'Published',
  [TEMPLATE_STATUS.ACTIVE]: 'Active',
  [TEMPLATE_STATUS.INACTIVE]: 'Inactive',
};

export function messageTemplateStatusLabel(status) {
  const key = String(status || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  if (LABELS[key]) return LABELS[key];

  // Fallback: humanize unknown statuses instead of showing "Draft".
  const human = key.replace(/_/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase());
  return human || 'Draft';
}
